<div class="gradiente">
    <div class="flecha-l">
      <div class="logo"></div>
    </div>
    <div class="iframe">
        <div class="login-options" *ngIf="show">
          <span class="login-option-txt">Accede a tu cuenta con</span>
          <a class="login-option-btn" [href]="cidiUrl">
              <img src="{{logoCidi}}" class="login-option-img" alt="cidi">
          </a>
          <a class="login-option-btn" [href]="arcaUrl">
              <img src="{{logoArca}}" class="login-option-img-arca" alt="arca">
          </a>
        </div>
    </div>
    <div class="flecha-r"></div>
  </div>
